import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FishHighlight } from './highlight';
import { FishTypeaheadWindow } from './typeahead-window';
import { FishTypeahead, FishTypeaheadSelectItemEvent } from './typeahead';
import { FishTypeaheadConfig } from './typeahead-config';

export { FishHighlight } from './highlight';
export { FishTypeaheadWindow } from './typeahead-window';
export { FishTypeaheadConfig } from './typeahead-config';
export { FishTypeahead, FishTypeaheadSelectItemEvent } from './typeahead';


export class FishTypeaheadModule {
  static forRoot(): ModuleWithProviders { return { ngModule: FishTypeaheadModule, providers: [FishTypeaheadConfig] }; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [FishTypeahead, FishHighlight, FishTypeaheadWindow],
  exports: [FishTypeahead, FishHighlight],
  imports: [CommonModule],
  entryComponents: [FishTypeaheadWindow]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
